export function trimARN(input: string): string {
    return input.match(/^[^/]+\/(?<test>.*)/)?.groups?.test ?? input;
}

export function guessRegion() {
    return "ap-southeast-2"; // works 100% of the time for me
}